import axios from "../utils/axios";
import { createContext } from "react";
import { errorBlock } from "../controllers/errorBlock";
import { getToken } from "../utils/token";

export const BillingContext = createContext();

const billingReducer = () => {
  return {
    setBilling: async (channelid, rate, units) => {
      try {
        let user = await getToken("spiral_username");
        let res = axios.post("/submeterbilling/setbillingmode", {
          username: user,
          channelid: channelid,
          rate: rate,
          minvend: units,
        });
        return res;
      } catch (err) {
        errorBlock(err.message);
      }
    },
    disableBilling: async (channelid) => {
      try {
        let username = await getToken("spiral_username");
        let res = axios.post("/submeterbilling/disablekwhbilling", {
          username,
          channelid: channelid,
        });
        return res;
      } catch (err) {
        errorBlock(err);
      }
    },
    getWalletBalance: async (currency) => {
      try {
        let username = await getToken("spiral_username");
        let res = axios.post("/transaction/getwalletbalance", {
          username,
          currency,
        });
        return res;
      } catch (err) {
        errorBlock(err);
      }
    },
    getVendhistory: async (startdate, enddate) => {
      try {
        let username = await getToken("spiral_username");
        let res = axios.post("/transaction/getwallettransactionhistory", {
          username,
          startdate,
          enddate,
        });
        return res;
      } catch (err) {
        errorBlock(err);
      }
    },
  };
};

export const BillingContextProvider = ({ children }) => {
  return (
    <BillingContext.Provider value={billingReducer()}>
      {children}
    </BillingContext.Provider>
  );
};
